<template>
    <div>
      
      <el-card class="login">
        <h1 slot="header">Логин</h1>
        <div>
          <el-row>
            <el-col :span="9" :offset="6">
              <el-button @click="facebook" type="primary">Facebook</el-button>
            </el-col>
            <el-col :span="9">
              <el-button @click="google" type="primary">Google</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">Email</el-col>
            <el-col :span="18"><el-input v-model="email" :class="{error: !email_valid}"/></el-col>
          </el-row>
          <el-row>
            <el-col :span="6">Password</el-col>
            <el-col :span="18"><el-input v-model="password" /></el-col>
          </el-row>
          <el-row>
            
            <el-col :span="9" :offset="6">
              <el-button type="primary" @click="submit">Войти</el-button>
            </el-col>
            <el-col :span="9">
              <router-link to="/signup">Нет аккаунта? Заргистрируйтесь</router-link>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
</template>
<script>
export default {
  name: "Signup",
  data() {
    return {
      email: null, 
      password: null,
    }
  },
  computed: {
    email_valid() {
      return this.email == null || this.email == '' || this.email.includes('@');
    },
    logged() {
      return this.$store.getters.logged;
    }
  },
  methods: {
    submit() {
      if(this.login && this.password && this.email_valid) {
        console.log('logging user');
        this.$store.dispatch("login", {email: this.email, password: this.password})
          .then((user) => {
            if(user.isAdmin) {
              this.$router.push('/admin');
            } else {
              this.$router.push('/currentGame');
            }
          })
          .catch(({message}) => this.$message({type: 'error', message}));
      } else {
        this.$message({type: 'warning', message: 'Заполните все поля'});
      }
    },
    facebook() {
      this.$store.dispatch('signin_facebook');
    },
    google() {
      this.$store.dispatch('signin_google');
    }
  },
  beforeMount(){
    if(this.logged) {
      const redirect = window.localStorage.getItem('redirect') || '/';
      window.localStorage.removeItem('redirect');
      this.$router.push(redirect).catch(e => console.log('router ex1', e));
    }
  },
  watch: {
    logged() {
      const redirect = window.localStorage.getItem('redirect') || '/';
      window.localStorage.removeItem('redirect');
      this.$router.push(redirect).catch(e => console.log('router ex', e));
    }
  }

}
</script>
<style scoped>
  .login {
    margin: auto;
    max-width: 500px;
  }
  .el-row {
    margin-bottom: 20px;
  }
</style>